import { useQueries } from "@tanstack/react-query";
import { System } from "../../../models/system";
import { QueryKeys } from "../../../types/query-key-enum";
import { getSalaries } from "../../../services/api/salary-api";

export const useSalaryQuery = (systems: System[]) => {
	const salaryQueries = useQueries({
		queries: systems.map((system) => {
			return {
				queryKey: [QueryKeys.Salary, system.name],
				queryFn: () => getSalaries(system.name),
				throwOnError: true,
			};
		}),
	});

	const isLoading = salaryQueries.some((x) => x.isLoading);

	return { isLoading, salaryQueries };
};
